import { render, staticRenderFns } from "./videoModel.vue?vue&type=template&id=c54b6c06&scoped=true"
import script from "./videoModel.vue?vue&type=script&lang=js"
export * from "./videoModel.vue?vue&type=script&lang=js"
import style0 from "./videoModel.vue?vue&type=style&index=0&id=c54b6c06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54b6c06",
  null
  
)

export default component.exports